



















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import { judgeDeviceType } from "@/utils/device";
import AiMoodPopup from './aiMoodPopup.vue';
import to from 'await-to-js';

import {
  toast
} from '@/utils/util';

@Component({
  components: {
    AiMoodPopup
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class StepText extends Vue {

  @Prop({ default: '' })
  defaultText: string;

  isApp = judgeDeviceType.isAPP;
  isSubmiting = false; // 正在生成中
  text: string = '';
  limitWordNum = 500; // 输入框最大字数
  placeHolder = '请输入或粘贴文案…(最多500字)'; // 输入框placeholder
  get textLength() {  // 输入框字数
    return this.text.trim().length
  }

  // 获取最终的文本，提交用
  get submitParams() {
    return {
      text: this.text,
      wordLimit: this.limitWordNum,
    }
  }

  mounted() {
    (window as any).getAppClipBordContent = this.getAppClipBordContent;
    this.getReferenceCopyList();
    if (this.defaultText) {
      this.setText(this.defaultText);
    }
  }

  // 提供给 app 的粘贴回调
  getAppClipBordContent(message: string) {
    message = decodeURI(message) || '';
    if (!message) return;
    this.setText(this.text + message);
  }
  // 点击粘贴按钮
  async pasteTxt() {
    if (this.isSubmiting) return;
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent;
      getClipBordContent.postMessage('');
    } else {
      try {
        const cptext = await navigator.clipboard.readText();
        this.setText(this.text + cptext);
      } catch (error) {
        toast("请点击输入框，长按粘贴内容");
        console.log('粘贴出错:', error);
      }
    }
  }

  // textarea 粘贴事件
  onPasteText(e) {
    try {
      e.preventDefault();  // 禁止默认事件，即粘贴的内容不放到文本框中
       // 获取剪贴板数据
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      this.setText(this.text + pastedData);
    } catch (error) {
      toast("请点击输入框，长按粘贴内容");
    }
  }

  // 字数限制动画结束
  onAnimationend() {
    (this.$refs.textLengthRef as any).classList.remove('word-num-anim')
  }
  clear() {
    this.setText('');
  }

  rmSymbol(text) {
    if (!text) return ''
    const reg = /「|」|\[|\]|"|“|'|'|【|】|<|>/g
    text = text.replace(reg, '')
    return text
  }

  setText(str) {
    if (this.isSubmiting) return;
    let text = this.rmSymbol(str.trim());
    if (text.length > this.limitWordNum) {
      (this.$refs.textLengthRef as any).classList.add('word-num-anim');
      toast(`请输入${this.limitWordNum}字以内的文本，超出部分将自动截断`, 'top', 4000);
      text = text.substring(0, this.limitWordNum);
    }
    this.text = text;
  }

  // 参考文案
  referenceCopyList = []
  async getReferenceCopyList() {
    const [err, res] = await to(this.$http('getRandomText', { typeEnum: 'DEFAULT' }));
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    this.referenceCopyList = res.data || [];
  }

  addText(str) {
    this.setText(this.text + str);
  }

  // AI心语
  isShowAiMood = false;
  showAiMood() {
    this.isShowAiMood = true;
  }
  closeAiMood() {
    this.isShowAiMood = false;
  }

  // 跳转创作记录页
  toWorksPage() {
    this.$router.push({
      path: '/migu-works',
    })
  }
}
